$block-gap: 14px;
$section-gap: var(--dixa-size-spacer-400);
$quote-bar-width: var(--dixa-size-spacer-100);
$list-indent: var(--dixa-size-spacer-300);

.bubble {
  padding: var(--dixa-size-spacer-200) var(--dixa-size-spacer-300);
  border-radius: var(--dixa-size-border-radius-100);
  word-break: break-word;

  > *:first-child {
    margin-top: 0;
  }

  > *:last-child {
    margin-bottom: 0;
  }
}

.bubbleUser {
  background-color: var(--dixa-color-neutral-100);
  align-self: flex-end;
  max-width: 85%;
}

.bubbleAssistant {
  align-self: flex-start;
  max-width: 100%;
  font-size: var(--dixa-typography-size-200);
  line-height: var(--dixa-typography-line-height-200);

  p,
  ul,
  ol,
  blockquote,
  pre,
  table {
    margin: 0 0 $block-gap;
  }

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  ul,
  ol,
  pre {
    text-box: trim-both cap alphabetic;
  }

  li ul,
  li ol,
  li p {
    text-box: normal;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: $section-gap 0 $block-gap;
    font-size: var(--dixa-typography-size-200);
    line-height: var(--dixa-typography-line-height-400);
    font-weight: var(--dixa-typography-weight-semibold);
  }

  ul,
  ol {
    padding-left: $list-indent;

    ul,
    ol {
      margin: 0;
    }
  }

  li:has(> input[type='checkbox']) {
    list-style: none;
    margin-left: calc(-1 * #{$list-indent});
  }

  input[type='checkbox'] {
    appearance: none;
    position: relative;
    box-sizing: border-box;
    width: var(--dixa-size-spacer-250);
    height: var(--dixa-size-spacer-250);
    margin: 0 var(--dixa-size-spacer-200) 0 0;
    vertical-align: -1px;
    border: var(--dixa-size-border-200) solid var(--dixa-color-neutral-800);
    border-radius: var(--dixa-size-border-radius-50);

    &:checked {
      background-color: var(--dixa-color-neutral-800);

      &::before {
        content: '';
        position: absolute;
        inset: calc(-1 * var(--dixa-size-border-200));
        background-color: var(--dixa-color-neutral-000);
        mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'%3E%3Cpath d='M3 6.2L5 8.2L9 4' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
      }
    }
  }

  table {
    border-collapse: collapse;
    width: 100%;
  }

  th,
  td {
    padding: 10px;
    border: var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);
    text-align: left;
  }

  th {
    background-color: var(--dixa-color-neutral-200);
    font-weight: var(--dixa-typography-weight-semibold);
  }

  th[align='center'],
  td[align='center'] {
    text-align: center;
  }

  th[align='right'],
  td[align='right'] {
    text-align: right;
  }

  blockquote {
    position: relative;
    padding: 0 0 0 calc(#{$quote-bar-width} + #{$block-gap});
    border: none;
    font-size: inherit;

    &::before {
      content: '';
      position: absolute;
      inset: 0 auto 0 0;
      width: $quote-bar-width;
      border-radius: var(--dixa-size-border-radius-50);
      background-color: var(--dixa-color-neutral-800);
    }

    > :last-child {
      margin-bottom: 0;
    }
  }

  code {
    padding: 0;
    border: none;
    border-radius: 0;
    background: none;
    color: inherit;
    font-family: var(--dixa-typography-family-code);
    font-size: inherit;
  }

  pre {
    margin-bottom: $section-gap;
    padding: 14px;
    border: none;
    color: inherit;
    font-size: inherit;
    line-height: inherit;
    overflow-x: auto;
    border-radius: var(--dixa-size-border-radius-100);
    background-color: var(--dixa-color-neutral-200);
  }

  hr {
    margin: $section-gap 0;
    border: none;
    border-top: var(--dixa-size-border-100) solid var(--dixa-color-neutral-800);
  }

  a {
    color: var(--dixa-typography-color-link);
    text-decoration: underline;
  }
}
